import React from 'react';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';

export const ServicesPerYearDonut = ({ heigth = 300 }) => {
    const { module } = useServicesChartsDataContext();
    const { subtitles, series } = useServicesPerYearDonutChart();

    return (
        <Donut
            title={`${module.sectionTitle} por Ano`}
            subtitles={subtitles}
            chartData={[]}
            series={series}
        />
    );
};
